import { LuSearch } from "@/Components/Icons/Icons.jsx";
export default {
  row1: [
  {
    column: "column1",
    rows: {
      row1: [
        {
          name: "exportProductBatchId",
          label: "Batch ID",
          component: "text-field",
        },
        {
          name: "exportProductBatchQuantity",
          label: "Batch Quantity",
          component: "text-field",
          dataType:"int"
        },
      ],
      row2: [
        {
          name: "exportProductBatchunit",
          label: "Batch Unit",
          component: "text-field",
          icon: LuSearch,
          iconColor: "gray-400",
          type: "autocomplete",
          endpoint : "getQuantity",
           width:"50%"
        },
        {
          name: "exportProductManufacuturerDate",
          label: "Manufacture Date",
          component: "dateselector",
          width:"50%"
        },
      ],
      row3: [
        {
          name: "exportProductExpiryDate",
          label: "Expiry Date",
          component: "dateselector",
          width:"50%"

          
        },
        {
          name: "exportProductBestBeforeDate",
          label: "Best Before Date",
          component: "dateselector",
          width:"50%"

          
        },
      ],
      
    },
  },
]
};
